import { render } from "./SessionClient.vue?vue&type=template&id=a731667c&scoped=true"
import script from "./SessionClient.vue?vue&type=script&lang=js"
export * from "./SessionClient.vue?vue&type=script&lang=js"

import "./SessionClient.vue?vue&type=style&index=0&id=a731667c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a731667c"]])

export default __exports__